export const redirectForTranslateFromEnglishToArabic = (text: string) => {
  if (!text) return;
  const url = `https://translate.google.com/?sl=en&tl=ar&text=${encodeURIComponent(text)}&op=translate`;
  window.open(url, "_blank");
};
